import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {httpClient} from "../../core/HttpClient";
import { useTranslation } from "react-i18next";
import Card from "@mui/material/Card";
import {getDatabase, goOffline, goOnline} from "firebase/database";
import { useIdleTimer } from 'react-idle-timer';
import {getDatabaseInstance} from "../../core/Firebase";
import {DateI18n} from "../DateI18n";
import AccountStatus from "../AccountStatus";

export default function AccountPlanCurrent() {
    const { t } = useTranslation();
    const [account, setAccount] = useState({});

    const onAction = (event) => {
        if(['visibilitychange','focus'].indexOf(event.type) > -1){
            if(document.visibilityState === 'hidden'){
                let app = getDatabaseInstance();
                const db = getDatabase(app);
                goOffline(db);
            } else if(document.visibilityState === 'visible'){
                let app = getDatabaseInstance();
                const db = getDatabase(app);
                goOnline(db);
            }
        }
    }

    useIdleTimer({
        onAction,
        timeout: 10_000,
        throttle: 500
    });

    useEffect(() => {
        console.log('[AccountPlanCurrent]');
        // const url = process.env.REACT_APP_API_BASE_URL + '/accounts/me/order/limited';
        // httpClient.get(url)
        //     .then(res => {
        //         if(res.data){
        //             setAccountLimit({
        //                 orderCurrent: res.data.orderCurrent || 0,
        //                 orderLimit: res.data.order || 0,
        //                 account: res.data.account,
        //                 plan: res.data.type
        //             });
        //         }
        //     });

        const url = process.env.REACT_APP_API_BASE_URL + '/accounts/me';
        httpClient.get(url)
            .then(res => {
                if(res.data){
                    setAccount(res.data);
                }
            });
    }, []);

    return (<Card variant="outlined">
        <Box m={2}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography color="inherit">
                    {t('account.accountId')}
                </Typography>
                <Typography color="textSecondary">
                    {account.cif}
                </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography color="inherit">
                    {t('shop.created')}
                </Typography>
                <Typography color="textSecondary">
                    <DateI18n value={account.created} format="DD MMM YYYY HH:mm" />
                </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography color="inherit">
                    {t('shop.state')}
                </Typography>
                <AccountStatus value={account.status} />
            </Box>
        </Box>
    </Card>
    )
}